<template>
    <AppScaffold grid>
        <Card v-if="data && !loading">
            <h1>{{ $tradFor(data.terms.name) }}</h1>
            <nav>
                <RoundedButton @click="$router.go(-1);">{{ $trad.common.cancel }}</RoundedButton>
                <RoundedButton @click="save">{{ $trad.common.save }}</RoundedButton>
            </nav>
            <ShelfForm ref="form" :data="shelfConfig"></ShelfForm>
        </Card>
        <Card v-else> <Loader :loading="true"></Loader> </Card>
    </AppScaffold>
</template>

<script>
import AppScaffold from "@/app-scaffold";
import TryLoad from "@/mixins/TryLoadMixin";
import componentService from "@/services/component";
import Loader from "@/components/loader/loader";
import Card from "./components/card";
import RoundedButton from "./components/rounded-button";
import ShelfForm from "./shelf-form";

export default {
    components: { AppScaffold, Loader, Card, RoundedButton, ShelfForm },
    mixins: [TryLoad],
    data: () => ({
        data: undefined,
        shelfConfig: {
            width: 200,
            height: 6,
            coverHeight: 16,
            coverY: 3,
            leftClip: {
                x: 5,
                y: 0
            },
            rightClip: {
                x: 5,
                y: 0
            },
            bottomAdhesive: false
        },
        isCaddy: false
    }),
    computed: {
        shelfId() {
            return this.$route.params.id && Number.parseInt(this.$route.params.id, 10);
        },
        component() {
            return (
                this.data && {
                    ...this.data,
                    config: this.isCaddy ? this.caddyConfig : this.shelfConfig
                }
            );
        }
    },
    created() {
        this.fetchShelf();
    },
    methods: {
        async fetchShelf() {
            this.data = await this.tryLoad(() => componentService.get(this.shelfId));
            this.isCaddy = (this.data.config && this.data.config.isCaddy) === true;
            this.shelfConfig = {
                ...this.shelfConfig,
                ...this.data.config
            };
        },
        async save() {
            try {
                // we use refs instead of having the logic here to keep things cleanly separated
                const config = this.$refs.form.validate.call(this.$refs);

                await componentService.updateConfig(this.shelfId, config);
                this.$router.go(-1);
            } catch (err) {
                this.dialogError(err);
                throw err;
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// shelf-editor.vue?a58f2bd4